import { createFileRoute } from "@tanstack/react-router";

import { PraxaMemorySurface } from "../components/praxa/PraxaMemorySurface";

export const Route = createFileRoute("/w/$workspaceId/memory")({
  component: PraxaMemoryRoute,
});

function PraxaMemoryRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaMemorySurface workspaceId={workspaceId} />;
}
